module.exports = __webpack_public_path__ + "img/首页底图@2x.65827c74.png";